import BanksDAO from "./BanksDAO";
import Bank from "./Bank";

class BanksService {

    static async getBank(countryCode: string, id: string): Promise<Bank | null> {
        const response = await BanksDAO.get(countryCode, id);

        return response.data ? Bank.fromServer(response.data) : null;
    }
}

export default BanksService;